import httpClient from '../config/httpClient';
import firebase from '../config/firebase.config';

export const connectKeka = async (
  companyId,
  userId,
  kekaCompanySlug,
  clientId,
  clientSecret,
  apiKey
) => {
  const { data } = await httpClient.post('/kekaConnect', {
    companyId,
    userId,
    kekaCompanySlug,
    clientId,
    clientSecret,
    apiKey,
  });
  return data;
};

export const disconnectKeka = async (companyId, userId) => {
  const { data } = await httpClient.post('/kekaDisconnect', {
    companyId,
    userId,
  });
  return data;
};

export const getKekaEmployees = async (companyId) => {
  const { data } = await httpClient.post('/kekaGetEmployees', { companyId });
  return data;
};

export const autoMapKekaEmployees = async (companyId, teamId) => {
  const { data } = await httpClient.post('/kekaAutoMapEmployees', {
    companyId,
    teamId,
  });
  return data;
};

export const saveKekaMappings = async (companyId, mappings) => {
  const { data } = await httpClient.post('/kekaSaveMappings', {
    companyId,
    mappings,
  });
  return data;
};

export const syncKekaTimeRange = async (
  companyId,
  teamId,
  startDate,
  endDate
) => {
  const { data } = await httpClient.post('/kekaSyncTimeRange', {
    companyId,
    teamId,
    startDate,
    endDate,
  });
  return data;
};

export const subscribeToKekaStatus = (companyId, onUpdate) => {
  return firebase
    .firestore()
    .collection('companyDatabase')
    .doc(companyId)
    .collection('integrations')
    .doc('keka')
    .onSnapshot(
      (doc) => {
        if (!doc.exists || !doc.data().connected) {
          onUpdate({
            connected: false,
            kekaCompanySlug: null,
            connectedAt: null,
            connectedBy: null,
            employeeMappings: {},
            employeeMappingsUpdatedAt: null,
            lastSyncAt: null,
            lastSyncStats: null,
          });
          return;
        }
        const d = doc.data();
        onUpdate({
          connected: true,
          kekaCompanySlug: d.kekaCompanySlug || null,
          connectedAt: d.connectedAt?.toDate?.() ?? null,
          connectedBy: d.connectedBy || null,
          employeeMappings: d.employeeMappings || {},
          employeeMappingsUpdatedAt:
            d.employeeMappingsUpdatedAt?.toDate?.() ?? null,
          lastSyncAt: d.lastSyncAt?.toDate?.() ?? null,
          lastSyncStats: d.lastSyncStats || null,
        });
      },
      (err) => {
        console.error('Keka status listener error:', err);
        onUpdate({
          connected: false,
          kekaCompanySlug: null,
          connectedAt: null,
          connectedBy: null,
          employeeMappings: {},
          employeeMappingsUpdatedAt: null,
          lastSyncAt: null,
          lastSyncStats: null,
        });
      }
    );
};
